import Button from '@insided/control/uikit/Button'

/* eslint-disable import/no-internal-modules */
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader
} from '@insided/deprecated-preact-components/design-system-components/modal'

interface RestoreModalProps {
  onRestore: () => void
  onClose: () => void
}
const RestoreModal = ({ onRestore, onClose }: RestoreModalProps) => {
  return (
    <Modal onClose={onClose} isControl>
      <ModalHeader title='Restore' />
      <ModalBody>Are you sure you want to restore the post to its original location?</ModalBody>
      <ModalFooter>
        <Button title='Restore' variant='success' onClick={onRestore} size='medium' />
        <Button title='Cancel' onClick={onClose} size='medium' />
      </ModalFooter>
    </Modal>
  )
}
export default RestoreModal
